import { shallowEqual } from 'react-redux';
import { createSelector, lruMemoize } from 'reselect';

import { globalSelector } from 'src/app/v1/dataAnalytics/PageViewTracker/selectors/globalSelector';
import type { AppState } from 'src/types/appState';

export const getTrackerSelector = <T>(pageSelector: (state: AppState) => T) =>
  createSelector(
    [globalSelector, pageSelector],
    (global, page) => ({
      ...global,
      ...page,
    }),
    {
      memoizeOptions: {
        ...lruMemoize,
        resultEqualityCheck: shallowEqual,
      },
    },
  );
